import { ComplianceDetails } from "./compliance-details";

const SelectedDetails = () => {
  return (
    <div>
      <ComplianceDetails />
    </div>
  );
};

export default SelectedDetails;
